var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6404 9.14C16.6404 15.82 9.00035 22.5 9.00035 22.5C9.00035 22.5 1.36035 15.82 1.36035 9.14C1.36035 7.11375 2.16528 5.17048 3.59806 3.7377C5.03083 2.30493 6.9741 1.5 9.00035 1.5C11.0266 1.5 12.9699 2.30493 14.4026 3.7377C15.8354 5.17048 16.6404 7.11375 16.6404 9.14Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00062 12C10.5802 12 11.8606 10.7196 11.8606 9.14003C11.8606 7.5605 10.5802 6.28003 9.00062 6.28003C7.42109 6.28003 6.14062 7.5605 6.14062 9.14003C6.14062 10.7196 7.42109 12 9.00062 12Z",
    stroke: "#55489E",
    strokeWidth: 1.91,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.2393eedf.svg";
export { ForwardRef as ReactComponent };